// Shared slug helpers for consistent normalization across the app
export function slugify(str) {
  const ascii = String(str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // strip diacritics
    .replace(/&/g, ' and ');
  return ascii
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export function initialsOf(str) {
  const ascii = String(str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  const parts = ascii.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  const inits = (first + last).toLowerCase();
  return inits || '';
}